import { ColorSelection } from '@web/components/utils/branding/types'

export const getCountdownTimerDefaultStyles = (colorData: ColorSelection) => {
  return {
    backgroundColor: '#FFFFFF00',
    labelColor: '#718096',
    timerColor: colorData['Brand'] ?? '#0D1216',
    borderRadius: 0,
  }
}
